import { useState } from 'react';
const useToggle = (startToggled = false) => {
    const [isToggled, setToggle] = useState(startToggled);
    const startToggle = () => setToggle(true);
    const endToggle = () => setToggle(false);
    return [isToggled, startToggle, endToggle];
};
export default useToggle;
//# sourceMappingURL=index.js.map